export default {"src":"/blog/_next/static/media/burger.3021dcf3.svg","height":19,"width":24};